module.exports = __webpack_public_path__ + "media/common/interview-examples2-ee5341af.svg";